import { Box, Typography } from '@mui/material';
import type { FC } from 'react';

interface Props {
  error: Error;
}

export const ErrorControl: FC<Props> = ({ error }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        m: 3,
      }}
    >
      <Box
        sx={{
          alignItems: 'center',
          alignSelf: 'center',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          maxWidth: 360,
          minHeight: '100%',
          mx: 'auto',
        }}
      >
        <Typography gutterBottom variant="h5">
          {error.name}
        </Typography>
        <Typography color="text.secondary">{error.message}</Typography>
      </Box>
    </Box>
  );
};
